// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { roundToNearestHours as fn } from "../roundToNearestHours.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const roundToNearestHours = convertToFP(fn, 1);

// Fallback for modularized imports:
export default roundToNearestHours;
